// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "chunk/" + chunkId + "." + {"452":"dea5682fe5e38b3a","510":"4687173b4bafc6ee","728":"2620d0f7bae0a651"}[chunkId] + ".js";
};